<div class="login-container">
  <p-card>
    <div style="text-align: center;" class="mb-5">
      <img src="../../../../assets/layout/images/coz_dark.png" height="60px" width="200px" />
    </div>

    <div class="contents-welcome" *ngIf="!showResetFlow">
      <h3 style="text-align: center">Welcome</h3>
      <p class="login" style="text-align: center">
        Login To Your Freight Audit Account
      </p>
      <!-- <div *ngIf="!showResetFlow" class="tabs-nav mb-4">
                <div
                    class="slider-tab"
                    [style.left.%]="activeTabIndex * (100 / tabs.length)"
                    [style.width.%]="100 / tabs.length"
                ></div>
                <div
                    *ngFor="let tab of tabs; let i = index"
                    class="tab-header"
                    [ngClass]="{ 'active-tab': activeTabIndex === i }"
                    (click)="setActiveTab(i)"
                >
                    {{ tab.label }}
                </div>
            </div> -->
    </div>
    <div *ngIf="activeTabIndex === 0 && !showResetFlow" class="flex justify-content-center align-items-center h-full">
      <form [formGroup]="loginForm" (ngSubmit)="emailPhaseCompleted ? loginFun() : onEmailSubmit()">
        <div class="field">

          <!-- Email Field -->
          <div class="form-group">
            <input type="email" pInputText id="confirmEmail" formControlName="email" required placeholder=""
              class="w-100 input-margin" />
            <label for="confirmEmail">Email</label>
            <small class="err-msg-pass"
              *ngIf="loginForm.controls['email'].errors?.['required'] && loginForm.controls['email'].touched">
              Please enter your email address
            </small>
            <small class="err-msg-pass"
              *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['pattern']">
              Please enter a valid email address
            </small>
          </div>

          <!-- Password Field: Shown only if emailPhaseCompleted and userType is 15 -->
          <div class="form-group" *ngIf="emailPhaseCompleted">
            <input [type]="showPassword ? 'text' : 'password'" pInputText formControlName="password" required
              placeholder=" " class="w-100 password1" id="password" />
            <label for="password">Password</label>
            <i [ngClass]="showPassword ? 'fas fa-eye':'fas fa-eye-slash'" (click)="togglePasswordVisibility()"></i>

            <small class="err-msg-pass1"
              *ngIf="loginForm.controls['password'].errors?.['required'] && loginForm.controls['password'].touched">
              Please enter your password
            </small>
          </div>

          <!-- Forgot Password -->
          <div class="row d-flex justify-content-center" style="text-align: right; margin-top: -11px;"
            *ngIf="emailPhaseCompleted">
            <a (click)="showResetFlow = true; step = 1" class="text-black cursor-pointer forgot-password">
              Forgot Password?
            </a>
          </div>

          <!-- Button -->
          <div class="row mt-4 d-flex justify-content-center" style="text-align: center;">
            <button class="login-btn" pButton pRipple
              [disabled]="loading || emailPhaseCompleted ? loginForm.invalid : loginForm.controls['email'].invalid" type="submit">
              <span class="text-center">{{emailPhaseCompleted ? 'Login' : 'Submit'}}
                <p-progressSpinner 
                  *ngIf="loading"
                  styleClass="w-1rem h-1rem" 
                  strokeWidth="4" 
                  animationDuration=".5s" />
              </span>
            </button>
            
            <div class="mt-4">
              <a *ngIf="emailPhaseCompleted" style="cursor: pointer; text-decoration: underline;"  (click)="emailPhaseCompleted = false">Back to Login</a>
            </div>

          </div>

        </div>
      </form>

    </div>

    <div *ngIf="activeTabIndex === 1 && !showResetFlow" class="tab-content">
      <form [formGroup]="loginForm" (ngSubmit)="loginFun()">
        <div class="field">
          <div class="form-group">
            <input type="email" pInputText id="confirmEmail" formControlName="email" required placeholder=""
              [feedback]="false" [toggleMask]="true" class="w-100 input-margin" />
            <label for="confirmEmail">Email</label>
            <small class="err-msg-pass"
              *ngIf="loginForm.controls['email'].errors?.['required'] && loginForm.controls['email'].touched">
              Please enter your email address
            </small>
            <small class="err-msg-pass"
              *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['pattern']">
              Please enter a valid email address
            </small>
          </div>



          <div class="form-group">
            <input [type]="showPassword ? 'text' : 'password'" pInputText formControlName="password" required
              placeholder=" " class="w-100 password1" id="password" />
            <label for="password">Password</label>
            <i [ngClass]="showPassword ? 'fas fa-eye-slash':'fas fa-eye'" (click)="togglePasswordVisibility()"></i>


            <small class="err-msg-pass1"
              *ngIf="loginForm.controls['password'].errors?.['required'] && loginForm.controls['password'].touched">
              Please enter your password
            </small>
          </div>

          <div class="row d-flex justify-content-center" style="text-align: right;margin-top: -11px;">
            <a (click)="showResetFlow = true; step = 1" class="text-black cursor-pointer forgot-password">Forgot
              Password?</a>
          </div>
        </div>

        <div class="row mt-4 d-flex justify-content-center" style="text-align: center;">
          <button class="login-btn" pButton pRipple [disabled]="loginForm.invalid" label="Login" type="submit"></button>
          <button class="login-btn" pButton pRipple
              [disabled]="loading || loginForm.invalid" type="submit">
              <span class="text-center">Login
                <p-progressSpinner 
                  *ngIf="loading"
                  styleClass="w-1rem h-1rem" 
                  strokeWidth="4" 
                  animationDuration=".5s" />
              </span>
            </button>
        </div>
      </form>
    </div>

    <!-- Add this just below your existing tab views -->
    <div *ngIf="showResetFlow" class="reset-password-container">
      <div *ngIf="step === 1">
        <h4 style="text-align: center">Forget Your Password?</h4>

        <p style="text-align: center" class="mb-4">
          Enter the email address associated with your account
        </p>

        <div class="form-group">
          <input type="email" id="resetEmail" name="resetEmail" pInputText [(ngModel)]="resetEmail"
            #resetEmailRef="ngModel" required placeholder="" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            class="w-100 input-margin" />
          <label for="resetEmail">Email Address</label>

          <small style="
                            color: red;
                            position: absolute;
                            left: 5px;
                            top: 53px;
                        " *ngIf="resetEmailRef.touched && resetEmailRef.errors?.['required']">
            Please enter your email address
          </small>
          <small style="color: red;
                        position: absolute;
                        left: 5px;
                        top: 53px;" *ngIf="resetEmailRef.touched && resetEmailRef.errors?.['pattern']">
            Please enter a valid email address
          </small>
        </div>
        <div class="OTP-buttons" style="text-align: center;">
          <button pButton type="button" label="Send OTP" [disabled]="!emailPattern.test(resetEmail)" (click)="sendOtp()"
            class="w-100 primary-btn"></button>
          <button pButton type="button" label="Back to Login" class="mt-2" (click)="cancelReset()"
            class="w-100 secondary-btn mt-2"></button>
        </div>
      </div>

      <div *ngIf="step === 2" style="text-align: center">
        <label>Enter Verification Code</label>
        <p>
          We have sent a code to
          <span style="font-weight: bolder; color: #002b45">{{
            resetEmail
            }}</span>
        </p>
        <div class="otp-container">
          <input *ngFor="
                            let val of otp;
                            let i = index;
                            trackBy: trackByIndex
                        " type="text" maxlength="1" [readonly]="
                            resendCountdown === 0 || failedAttempts === true
                        " class="otp-box" [ngModel]="otp[i]" (ngModelChange)="onOtpChange($event, i)"
            (input)="moveFocus(i, $event)" />
        </div>
        <button pButton type="button" label="Verify OTP" *ngIf="resendCountdown != 0 && failedAttempts == false"
          (click)="verifyOtp()" class="w-100 mt-2 primary-btn"></button>
        <div class="mt-2">
          <p *ngIf="resendCountdown > 0 && failedAttempts == false">
            You can resend OTP in {{ resendCountdown }} seconds
          </p>
          <button *ngIf="resendCountdown == 0 || failedAttempts == true" pButton type="button" label="Resend OTP"
            (click)="resendOtp()" class="w-100 mt-2 primary-btn"></button>
        </div>
        <button pButton type="button" label="Back" class="mt-2 primary-btn" (click)="goToStep(1)"></button>
      </div>

      <form [formGroup]="step3Form" class="password-confirm" *ngIf="step === 3" class="confirm-password">
        <!-- New Password -->
        <div class="form-group1">
          <input [type]="showNewPassword ? 'text' : 'password'" pInputText formControlName="newPassword" required
            placeholder=" " class="w-100 password1" id="newPassword" />
          <label for="newPassword">New Password</label>
          <i [ngClass]="showNewPassword ? 'fas fa-eye-slash':'fas fa-eye'" (click)="toggleNewPasswordVisibility()"></i>

          <small *ngIf="
        step3Form.controls.newPassword.touched &&
        step3Form.controls.newPassword.errors?.['required']
      " class="err-msg-pass2">
            Please enter your new password.
          </small>

          <small *ngIf="
        step3Form.controls.newPassword.touched &&
        step3Form.controls.newPassword.errors?.['pattern']
      " class="err-msg-pass2">
            Password must be at least 8 characters long and include
            uppercase, lowercase, number, and special character.
          </small>
        </div>

        <!-- Confirm Password -->
        <div class="form-group1">
          <input [type]="showConfirmPassword ? 'text' : 'password'" pInputText formControlName="confirmPassword"
            required placeholder=" " class="w-100 password1" id="confirmPassword" />
          <label for="confirmPassword">Confirm Password</label>
          <i [ngClass]="showConfirmPassword ?'fas fa-eye-slash':'fas fa-eye'"
            (click)="toggleConfirmPasswordVisibility()"></i>

          <small *ngIf="
        step3Form.controls.confirmPassword.touched &&
        step3Form.controls.confirmPassword.errors?.['required']
      " class="err-msg-pass2">
            Please confirm your new password.
          </small>

          <small *ngIf="
        step3Form.controls.confirmPassword.touched &&
        !step3Form.controls.confirmPassword.errors?.['required'] &&
        step3Form.errors?.['passwordsMismatch']
      " class="err-msg-pass2">
            Passwords do not match.
          </small>
        </div>

        <div class="Reset-buttons" style="text-align: center;">
          <button pButton type="button" label="Reset Password" class="w-100 mt-5 primary-btn" (click)="resetPassword()"
            [disabled]="step3Form.invalid"></button>
          <button pButton type="button" label="Back" class="mt-2 primary-btn" (click)="goToStep(1)"></button>
        </div>
      </form>
    </div>
  </p-card>
</div>

<p-toast position="top-center" [preventOpenDuplicates]="true"
  [style]="{ width: '320px', textAlign: 'center', marginTop: '0px' }" />